(function () {
  'use strict';

  let faqSections = [];
  let selectedSections = new Set();
  let currentSearchTerm = '';

  function getAllFAQSections() {
    // Get all collapsible content sections on the page
    const sections = document.querySelectorAll('[class*="collapsible-content"], .accordion, details');

    if (sections.length === 0) {
      return [];
    }

    const sectionsMap = new Map(); // Use Map to handle duplicates
    const sectionsArray = [];

    Array.from(sections).forEach((section, index) => {
      // Try to find the heading in various ways
      let heading = '';
      let headingElement = null;

      // Look for collapsible-content__heading
      headingElement = section.querySelector('.collapsible-content__heading');
      if (headingElement) {
        heading = headingElement.textContent.trim();
      }

      // Skip empty headings or very short ones
      if (!heading || heading.length < 2) {
        return;
      }

      const sectionId = section.id || `section-${index}`;

      // Handle duplicates by grouping them
      if (sectionsMap.has(heading)) {
        // Add this section to the existing group
        sectionsMap.get(heading).elements.push(section);
      } else {
        // Create new entry
        const sectionData = {
          elements: [section],
          heading: heading,
          id: sectionId,
          index: sectionsArray.length,
          originalContent: new Map(), // Store original content for restoration
        };

        // Store original content for each element
        sectionData.elements.forEach((el) => {
          sectionData.originalContent.set(el, el.innerHTML);
        });

        sectionsMap.set(heading, sectionData);
        sectionsArray.push(sectionData);
      }
    });

    console.log('Found unique sections:', sectionsArray);
    return sectionsArray;
  }

  function renderCategoryBadges() {
    const badgesContainer = document.getElementById('faq-category-badges');
    if (!badgesContainer) return;

    // Clear existing badges except the "All" button
    const allButton = badgesContainer.querySelector('[data-category="all"]');
    badgesContainer.innerHTML = '';

    // Add badges for each section
    faqSections.forEach((section, index) => {
      const badge = document.createElement('button');
      badge.className = 'category-badge section-badge';
      badge.setAttribute('data-section-id', section.id);
      badge.setAttribute('data-section-index', index);

      const isSelected = selectedSections.has(section.id);

      // Add selected class if this section is selected
      if (isSelected) {
        badge.classList.add('selected');
      }

      badge.innerHTML = `
        <span class="badge-text">${section.heading}</span>
        <span class="badge-remove ${isSelected ? 'selected' : ''}" aria-label="Remove ${section.heading}">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14 2L2.00001 14" stroke="#667C67" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M2 2L14 14" stroke="#667C67" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </span>
      `;

      // Add click handler for the badge (to toggle selection)
      badge.addEventListener('click', function (e) {
        e.stopPropagation();

        // If clicking the remove button
        if (e.target.closest('.badge-remove')) {
          toggleSectionSelection(section.id, false);
        } else {
          // Toggle selection
          toggleSectionSelection(section.id);
        }
      });

      badgesContainer.appendChild(badge);
    });

    // Update "All" button handler
    if (allButton) {
      allButton.replaceWith(allButton.cloneNode(true)); // Remove existing listeners
      const newAllButton = badgesContainer.querySelector('[data-category="all"]') || allButton;
      newAllButton.addEventListener('click', function () {
        clearAllSelections();
      });

      badgesContainer.appendChild(newAllButton);
    }
  }

  function clearAllSelections() {
    selectedSections.clear();
    updateVisibility();
    updateBadgeStates();
    updateAllButtonState();
  }

  function toggleSectionSelection(sectionId, forceState = null) {
    const isCurrentlySelected = selectedSections.has(sectionId);

    if (forceState === null) {
      // Toggle
      if (isCurrentlySelected) {
        selectedSections.delete(sectionId);
      } else {
        selectedSections.add(sectionId);
      }
    } else {
      // Force to specific state
      if (forceState) {
        selectedSections.add(sectionId);
      } else {
        selectedSections.delete(sectionId);
      }
    }

    updateVisibility();
    updateBadgeStates();
    updateAllButtonState();
  }

  function highlightSearchTerm(text, searchTerm) {
    if (!searchTerm) return text;

    const regex = new RegExp(`(${escapeRegExp(searchTerm)})`, 'gi');
    return text.replace(regex, '<mark class="search-highlight">$1</mark>');
  }

  function escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  function removeHighlights(element) {
    const highlights = element.querySelectorAll('.search-highlight');
    highlights.forEach((highlight) => {
      const parent = highlight.parentNode;
      parent.replaceChild(document.createTextNode(highlight.textContent), highlight);
      parent.normalize(); // Merge adjacent text nodes
    });
  }

  function addHighlights(element, searchTerm) {
    if (!searchTerm) return;

    const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT, null, false);

    const textNodes = [];
    let node;
    while ((node = walker.nextNode())) {
      textNodes.push(node);
    }

    textNodes.forEach((textNode) => {
      if (textNode.textContent.toLowerCase().includes(searchTerm.toLowerCase())) {
        const parent = textNode.parentNode;
        if (parent && !parent.classList.contains('search-highlight')) {
          const highlightedHTML = highlightSearchTerm(textNode.textContent, searchTerm);
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = highlightedHTML;

          while (tempDiv.firstChild) {
            parent.insertBefore(tempDiv.firstChild, textNode);
          }
          parent.removeChild(textNode);
        }
      }
    });
  }

  function updateVisibility() {
    const hasSearchTerm = currentSearchTerm.length > 0;
    const nothingSelected = selectedSections.size === 0;

    faqSections.forEach((section) => {
      let shouldShow = false;
      let matchesSearch = true;

      // Category filtering logic
      const isSelected = selectedSections.has(section.id);
      const categoryMatch = nothingSelected || isSelected;

      // Search filtering logic
      if (hasSearchTerm) {
        const headingMatches = section.heading.toLowerCase().includes(currentSearchTerm.toLowerCase());
        let contentMatches = false;

        section.elements.forEach((element) => {
          if (element.textContent.toLowerCase().includes(currentSearchTerm.toLowerCase())) {
            contentMatches = true;
          }
        });

        matchesSearch = headingMatches || contentMatches;
      }

      // Show if passes both category and search filters
      shouldShow = categoryMatch && matchesSearch;

      section.elements.forEach((element) => {
        // Remove existing highlights
        removeHighlights(element);

        if (shouldShow) {
          element.style.display = '';
          element.classList.remove('faq-hidden');

          // Add search highlights if there's a search term
          if (hasSearchTerm && matchesSearch) {
            addHighlights(element, currentSearchTerm);
            element.classList.add('search-match');
          } else {
            element.classList.remove('search-match');
          }
        } else {
          element.style.display = 'none';
          element.classList.add('faq-hidden');
          element.classList.remove('search-match');
        }
      });
    });

    // Show search results summary
    updateSearchResultsCount();
  }

  function updateSearchResultsCount() {
    const hasSearchTerm = currentSearchTerm.length > 0;
    if (!hasSearchTerm) return;

    const visibleSections = faqSections.filter((section) => {
      return section.elements.some((el) => !el.classList.contains('faq-hidden'));
    });

    // You can add a results counter element to show how many results were found
    const resultsCount = visibleSections.length;
    console.log(`Search found ${resultsCount} matching sections`);
  }

  function updateBadgeStates() {
    const badges = document.querySelectorAll('.section-badge');
    badges.forEach((badge) => {
      const sectionId = badge.getAttribute('data-section-id');
      const isSelected = selectedSections.has(sectionId);

      badge.classList.toggle('selected', isSelected);
      badge.querySelector('.badge-remove').classList.toggle('selected', isSelected);
    });
  }

  function updateAllButtonState() {
    const allButton = document.querySelector('[data-category="all"]');
    if (!allButton) return;

    const allSelected = selectedSections.size === faqSections.length;
    const noneSelected = selectedSections.size === 0;

    allButton.classList.toggle('selected', noneSelected);
    allButton.classList.toggle('active', noneSelected);
  }

  function setupSearch() {
    const searchInput = document.getElementById('faq-search-input');
    if (!searchInput) return;

    let debounceTimer;

    searchInput.addEventListener('input', function () {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        currentSearchTerm = this.value.trim();
        updateVisibility();
      }, 300);
    });

    // Clear search when input is cleared
    searchInput.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        this.value = '';
        currentSearchTerm = '';
        updateVisibility();
      }
    });
  }

  function waitForDOM(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
    } else {
      callback();
    }
  }

  function init() {
    // Get all collapsible sections
    faqSections = getAllFAQSections();

    if (faqSections.length === 0) {
      console.log('No FAQ sections found');
      return;
    }

    // Render the category badges
    renderCategoryBadges();

    // Setup search functionality
    setupSearch();

    // Initial visibility update
    updateVisibility();
    updateAllButtonState();

    // Make sections available globally for debugging
    window.faqSections = faqSections;
    window.selectedSections = selectedSections;

    console.log('FAQ search and filter system initialized');
    return faqSections;
  }

  // Initialize when DOM is ready
  waitForDOM(init);
})();
